
































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class Name extends Vue {
    /* ------------- Data -------------------- */

    /* ------------- Props ------------------- */
    @Prop({type: Array, default: () => [] })
    private nodes: any[];

    @Prop({default: false}) private subMenu: boolean;

    @Prop({default: false}) private dark: boolean;

    @Prop({default: false}) private horizontal: boolean;

    @Prop({default: false}) private horizontalHover: boolean;

    @Prop({default: false}) private horizontalCenter: boolean;

    @Prop({default: false}) private horizontalJustify: boolean;


    /* ------------- Computed ---------------- */
    get classContainer() {
        return {
            'nav-main': !this.subMenu,
            'nav-main-submenu': this.subMenu,
            'nav-main-dark': this.dark,
            'nav-main-horizontal': this.horizontal,
            'nav-main-hover': this.horizontalHover,
            'nav-main-horizontal-center': this.horizontalCenter,
            'nav-main-horizontal-justify': this.horizontalJustify,
        };
    }
    /* ------------- Methods ----------------- */
    private subIsActive(paths: any) {
        const activePaths = Array.isArray(paths) ? paths : [paths];

        return activePaths.some((path) => {
            return this.$route.path.indexOf(path) === 0; // current path
        });
    }

    private linkClicked(e: any, submenu: boolean) {
        // Get window width
        const windowW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        if (submenu) {
            // get closest li element
            const el = e.target.closest('li');

            // check if we are in a large screen, have horizontal nav and hover is enabled
            if (!(windowW > 991 && this.horizontal && this.horizontalHover)) {
                if (el.classList.contains('open')) {
                    // if submenu is open, close it
                    el.classList.remove('open');
                } else {
                    // .. else if submenu is closed, close all other (same level)
                    el.closes('ul').children.forEach((element: any) => {
                        element.classList.remove('open');
                    });
                    el.classList.add('open');
                }
            }
        } else {
            // if we are in mobile, close the sidebar
            if (windowW < 992) {
                // TODO: wire up the store 
                // this.$store.commit('sidebar', { mode: 'close'});
            }
        }
    }
    /* ------------- Lifecycle Hooks --------- */
}
